//PROD
export const API = "https://api.ago.feam.org"
export const host = "https://ago.feam.org"

// DEV
// export const API = "https://dev-api.feam.org"
// export const host = "https://dev.feam.org"

export const access_list = [
    {Label: 'Gestion des délégués', ButtonLabel:'Délégués', Value: '/delegues'},
    {Label: 'Bénéficiaires repas', ButtonLabel:'Bénéficiaires repas', Value: '/beneficiaires_repas'},
    {Label: 'Scan', ButtonLabel:'Scan', Value: '/scan'},
    {Label: 'Présence en temps réel', ButtonLabel:'Présences', Value: '/realtime_presence/:sessionId'},
    {Label: 'Gestion des sessions de scan', ButtonLabel:'Sessions', Value: '/sessions'},
    {Label: 'Gestion des utilisateurs', ButtonLabel:'Utilisateurs', Value: '/users'},
    {Label: 'Envoie de SMS', ButtonLabel:'SMS', Value: 'sms'},
    {Label: 'Gestion des votes', ButtonLabel:'Votes', Value: '/votes'},
    {Label: 'Scan de vote', ButtonLabel:'Scan de vote', Value: '/scan_vote'}
]

export const categories = ['Délégué de droit', 'Délégué régulier', 'autre']
export const list_repas = ['Vendredi soir', 'Samedi midi', 'Samedi soir', 'Dimanche midi', 'Dimanche soir']